<script setup>
</script>

<template>
  <div>
    <input
      style="display: none"
      type="file"
      ref="file"
      @change="handleChange"
    />
    <div
      class="box"
      @click="$refs.file.click()"
      style="
        border: 1px solid #ccc;
        background: #f5f5f5;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #666;
      "
    >
      <div id="file-name">{{fileName}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onSubmit: Function,
    dynamicLabel: String,
  },
  created(){
    if(this.dynamicLabel !== undefined){
      this.fileName = this.dynamicLabel
    }
  },
  data: () => ({
    fileName: "Select a .csv file"
  }),
  methods: {
    handleChange: function (e) {
      this.onSubmit(e.target.files[0]);
        this.fileName = e.target.files[0].name;
    },
  },
  name: "FileUploader",
};
</script>

<style scoped>
.description {
  font: -webkit-control;
}
.box {
  width: 100%;
  min-height: 100px;
  border-radius: 4px;
  cursor: pointer;
}
input, select, option, textarea {
  border: 1px solid grey;
}
</style>